import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

// Keyboard.resize is set to "none" (see capacitor.base-config.ts) so the
// WKWebView's own frame never resizes. Capacitor's keyboardWillShow fires
// before the keyboard's own animation starts (unlike dvh, which only
// updates once a native resize finishes), so driving #__nuxt's height from
// this event lets our CSS transition run in sync with the real keyboard
// motion instead of visibly lagging a beat behind it.
//
// Native only — plain web/Safari never sets --keyboard-height, so app.vue's
// calc() falls back to plain 100dvh there, unchanged from browser default.
export default defineNuxtPlugin(() => {
  if (!Capacitor.isNativePlatform()) return;

  const setKeyboardHeight = (height: number) => {
    document.documentElement.style.setProperty(
      "--keyboard-height",
      `${Math.max(0, Math.round(height))}px`,
    );
  };

  setKeyboardHeight(0);

  Keyboard.addListener("keyboardWillShow", (info) => {
    setKeyboardHeight(info.keyboardHeight);
  });

  Keyboard.addListener("keyboardWillHide", () => {
    setKeyboardHeight(0);
  });
});
